<ul>
  {{#hits}}
    <li>
      <a href="{{slug}}">{{title}}</a>
      <div>{{tagline}}</div>
    </li>
  {{/hits}}
  {{^hits}}
    <li>
      No results found
    </li>
  {{/hits}}
</ul>
